import { render, staticRenderFns } from "./DetailBookingBulk.vue?vue&type=template&id=d9c1d0c0&scoped=true&"
import script from "./DetailBookingBulk.vue?vue&type=script&lang=js&"
export * from "./DetailBookingBulk.vue?vue&type=script&lang=js&"
import style0 from "./DetailBookingBulk.vue?vue&type=style&index=0&id=d9c1d0c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c1d0c0",
  null
  
)

export default component.exports